/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';

import WidgetDialog from '../components/dialogs';
import ContentContainer from '../components/contentContainer';
import TitleHeader from '../components/titleHeader';
import GuideLink from '../components/guidelink';
import ActionLink from '../components/actionlink';
import WaitSpinner from '../components/waitspinner';

import { useStyles } from './styles';
import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import getCommonUIStyles from '../../commons/uiStyles';

import useSubscriber from '../../store/models/subscriber/useSubscriber';
import useUIStates from '../../store/models/uistates/useUIStates';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';
import useKickstarted from '../../commons/hooks/useKickstarted';

function HavingTrouble (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const  {
        translate,
    } = useTranslator();

    const [spinnerVisible, setSpinnerVisible] = useState(false);

    const  {
        isPolling,
    } = useSubscriber();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const {
        appStore,
        selectedCalendar,
    } = useUIStates();
 
    const classes = useStyles({
        widget,
        widgetTheme,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });

    useEffect(() => {
        setSpinnerVisible(isPolling);
    }, [isPolling]);

    useKickstarted({
        onKickstarted: () => {},
    });

    usePageTransitions({
        elementName: TransitionViewNames.HAVING_TROUBLE_VIEW,
        viewAnimation,
    });

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    isShowBackButton={false}
                    name={TransitionViewNames.HAVING_TROUBLE_VIEW}
                    viewAnimation={viewAnimation}
                    initStyles={initStyles}
                >
                    <TitleHeader
                        widget={widget}
                        widgetTheme={widgetTheme}
                        title={`${translate(TranslationIds.CALENDAR_REPROC_TITLE)}`}
                        subtitle={''}
                    />

                    <Grid className={classNames([classes.body])}>

                        {   
                            selectedCalendar !== 'ics_other' &&
                            <Grid className={classes.spinnerBox}>
                                <WaitSpinner
                                    visible={spinnerVisible}
                                    commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                    text={translate(TranslationIds.CALENDAR_PROC_SPINNER)}
                                />
                            </Grid>
                        }

                        <Grid className={classes.tryagain}>
                            { translate(TranslationIds.CALENDAR_REPROC_TRY_AGAIN) }
                            <ActionLink
                                label={translate(TranslationIds.CALENDAR_PROC_CLICK_HERE)}
                                commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                onClick={() => {
                                    setSpinnerVisible(true);
                                    appStore.tryAgain({selectedCalendar});
                                }}
                            />
                        </Grid>

                        <Grid className={classes.help}>
                            { translate(TranslationIds.CALENDAR_PROC_NEED_HELP) }
                            <GuideLink
                                selectedCalendar={selectedCalendar}
                                label={translate(TranslationIds.CALENDAR_PROC_GUIDE)}
                                commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                            />
                        </Grid>
                    </Grid>

                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

HavingTrouble.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(HavingTrouble);